import React, { useEffect, useState } from 'react';
import { config } from '../../../../../../config';
import axiosApi from '../../../../../../core/interceptor/interceptor';
import moment from 'moment';
import InfiniteScroll from 'react-infinite-scroll-component';
import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';
import WarningDialogue from '../../../../../../Util/WarningDialogue';

function List(props) {
    const [classifieds, setClassifieds] = useState([]);
    const [page, setPage] = useState(1);
    const [open, setOpen] = useState(false);
    const [popUpContent, setPopUpContent] = useState({});
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        getClassified(props.status || 'pending');
        //eslint-disable-next-line
    }, [page])

    const getClassified = (status, pg = 1) => {
        setLoading(true);
        axiosApi.get(`${config.apiUrl}/classifieds?status=${status}`, {
            params: {
                page,
            }
        })
            .then((resp) => {
                setLoading(false);
                if (resp.data &&
                    resp.data.data &&
                    resp.data.data.length >= 0) {
                    if (page > 1) {
                        setClassifieds([...classifieds, ...resp.data.data]);
                    } else {
                        setClassifieds([...resp.data.data]);
                    }
                }
            }).catch((err) => {
                setLoading(false);
            })
    }

    const updateClassifieds = (id, status = null) => {
        if (id > 0) {
            if (status) {
                axiosApi.put(`${config.apiUrl}/classifieds/${id}`, { status })
                    .then(() => {
                        setOpen(false);
                        spliceClassifieds(id);
                    })
                    .catch((err) => {
                        console.error(err);
                    });
            } else {
                axiosApi.delete(`${config.apiUrl}/classifieds/${id}`)
                    .then(() => {
                        setOpen(false);
                        spliceClassifieds(id);
                    })
                    .catch((err) => {
                        console.error(err);
                    })
            }
        }
    }

    const popUpHandler = (id, status = null) => {
        setOpen(true);
        setPopUpContent({
            header: props.status === 'pending' ? 'Approve' : 'Delete',
            description: `Are you sure you want to ${props.status === 'pending' ? 'approve' : 'delete'} this classified?`,
            icon: faExclamationTriangle,
            action: () => updateClassifieds(id, status),
        });
    }

    const spliceClassifieds = (id) => {
        const classifieds_ = classifieds;
        const idx = classifieds.findIndex(classified => classified.id === id);
        if (idx > -1) {
            classifieds_.splice(idx, 1);
        }
        setClassifieds([...classifieds_]);
    }

    return <>
        <div id="scrollableDiv" style={{ height: "calc(88vh - 3px)", overflow: "auto" }}>
            <InfiniteScroll
                dataLength={classifieds.length}
                next={() => setPage(prev => prev + 1)}
                hasMore={true}
                scrollableTarget="scrollableDiv"
            >
                {
                    classifieds.length ?
                        classifieds.map((x, i) => (
                            <div key={i} className="classsifieds">
                                <div className="classifieds-left">
                                    <h5>{x.title}</h5>
                                    <span className="post">(Posted {moment(x.created_at).format('M/DD/YYYY h:mm:ss A')} by {x.user.email})</span>
                                    <p className="description">{x.description}</p>
                                    <p className="date-until">Display Until: {moment(x.display_until).format('M/DD/YYYY hh:mm A')}</p>
                                </div>
                                <div className="classifieds-right">
                                    <span className='btn' style={{
                                    }} onClick={() => props.status === 'pending' ? popUpHandler(x.id, 'approved') : popUpHandler(x.id)}>{props.status === 'pending' ? 'Approve' : props.status === 'approved' ? 'Delete' : ''}</span>
                                </div>
                            </div>
                        ))
                        : (!loading && <div className="noRecord-found-classifieds">No record found</div>)
                }
            </InfiniteScroll>
        </div>
        <WarningDialogue
            isOpen={open}
            header={popUpContent.header}
            description={popUpContent.description}
            icon={popUpContent.icon}
            action={popUpContent.action}
            onClose={() => setOpen(false)}
        />
    </>
}

export default List;